import { Variant } from "../../../../Interfaces/Product";
import { IConfiguratorUpdater } from "../types";
import { SELECTORS } from "../Constants";
import SCROLLER_CONSTANTS from "../../../../Components/Scroller/Constants";

export class Gallery implements IConfiguratorUpdater {
    private images: HTMLElement[];
    private detailSection: HTMLElement;
    private readonly relations: { [key: string]: string[] };

    constructor(private readonly node: HTMLElement) {
        this.node = node;
        this.relations = JSON.parse(node.dataset.imageRelation) || {};
        this.initElements();
    }

    private initElements() {
        this.detailSection = this.node.closest(SELECTORS.CLOSEST_DETAIL_SECTION);
        this.images = [...this.detailSection.querySelectorAll<HTMLElement>(SELECTORS.GALLERY_IMAGES)];
    }

    update(v: Variant): void {
        const scroller = this.detailSection.querySelector(SCROLLER_CONSTANTS.SELECTORS.SCROLLER);
        if (scroller && v.sku) {
            this.images.forEach((i) => {
                const filename = i.dataset.file;
                const relation = this.relations[v.sku];
                i.classList.toggle(SCROLLER_CONSTANTS.CLASSES.HIDDEN_ITEM, !relation || relation.indexOf(filename) < 0);
            });
            scroller.dispatchEvent(
                new CustomEvent(SCROLLER_CONSTANTS.EVENTS.SCROLLER_GOTO, {
                    detail: {
                        index: 0,
                        behavior: "instant"
                    }
                })
            );
        }
    }
}
